// 服务台和CDS入口，搜索区域
<template>
  <div class="out-input">
    <div>
      <!-- 跳转系统外两个按钮 -->
      <div class="cds">
        <!-- 判断下，只有在首页时，显示两个登录区域 -->
        <template v-if="pagePath">
          <!-- 页面路径 -->
          <!-- <el-breadcrumb separator="/">
						<el-breadcrumb-item>{{pagePath}}</el-breadcrumb-item>
					</el-breadcrumb> -->
          <div class="page-path">
            <p>
              <i class="el-icon-s-home"></i>当前位置：<span
                style="font-weight: normal"
                >{{ pagePath }}</span
              >
            </p>
          </div>
        </template>
        <!-- 不展示页面路径的情况下，展示其它系统的登录入口 -->
        <template v-else>
          <div class="btn-box">
            <div :style="{ backgroundImage: `url(${login02})` }">
              <div class="login-01">
                <span>中国民航分销结算平台入口</span>
                <p @click="toCds">GO</p>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <div
              class="login-02"
              :style="{ backgroundImage: `url(${login01})` }"
            >
              <p>CDS服务中心 <span @click="toCdsCenter">注册登录</span></p>
            </div>
          </div>
        </template>
      </div>
      <!-- 页面输入 -->
      <div class="search">
        <div class="input">
          <input
            v-model.trim="searchText"
            placeholder="请输入信息"

          />
          <!-- @focus="inputFouce = true" @blur="inputFouce = true" @input="handleInput" -->
        </div>
        <div class="btn" @click="handleSearch">
          <span>搜</span>
          <span>索</span>
        </div>
        <!-- 绝对定位，使用一个卡片，来当作远程搜索的结果展示框 -->
        <div class="search-items" v-show="inputFouce">
          <v-clamp
            class="item"
            autoresize
            :max-lines="1"
            v-for="(item, index) of searchList"
            :key="'search-items' + index"
            >{{ item }}</v-clamp
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import login01 from "../assets/login01.png";
import login02 from "../assets/login02.png";
import VClamp from "vue-clamp";
import { Message } from "element-ui";
export default {
  name: "InputOut",
  components: { VClamp },
  data() {
    return {
      login01, // 两个背景图
      login02,
      searchText: "",
      searchList: [], // 搜索结果
      inputFouce: false,
    };
  },
  computed: {
    pagePath() {
      // console.log(this.$route)
      return this.$route.path === "/" ? "" : this.$route.query.label;
    },
  },

  methods: {
    // 处理输入事件，每次输入时，都给搜搜列表增加一项内容
    handleInput() {
      this.searchList.push("handleInput");
    },
    // 处理失焦时的搜索
    handleSearch() {
      const searchText = this.searchText.trim().slice(0, 50);
      if (this.searchText) {
        this.searchText = "";
        this.$router.push({
          path: "/article",
          query: { searchText, label: "搜索结果" },
        });
      }
      // const regs = /^[a-zA-Z0-9\u4e00-\u9fa5]{1,50}$/g
      // if (regs.test(this.searchText)) {
      //   this.$router.push({
      //     path: '/article',
      //     query: { searchText: this.searchText, label: '搜索结果' }
      //   })
      // } else {
      //   this.searchText = ''
      //   Message({
      //     message: '只能搜索50个中英文或数字',
      //     duration: 1500,
      //     type:'error'
      //   })
      // }
    },
    // 中国民航分销结算平台进入
    toCds() {
      window.open(process.env.VUE_APP_CDS_WEB);
    },
    // CDS服务中心
    toCdsCenter() {
      window.open(process.env.VUE_APP_CDS_RECEPTION);
    },
  },
};
</script>

<style lang="less" scoped>
.out-input {
  // width: 100%;
  // min-width: 1270px;
  width: 1300px;
  height: 100px;
  margin: auto;
  background-color: #f5f5f5;
  display: flex;
  & > div {
    width: 1270px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  // 跳转按钮区域
  .cds {
    height: 61px;
    // width: 680px;
    width: 0;
    flex-grow: 2;
    display: flex;
    justify-content: space-between;
    .btn-box {
      width: 0;
      flex-grow: 1;
      display: flex;
      & > div {
        width: 328px;
        height: 61px;
        border-radius: 10px;
        // background-color: #5a8ce7;
        color: #fff;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .login-01 {
        width: 200px;
        height: 41px;
        position: relative;
        left: 110px;
        top: 13px;
        bottom: 7px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        user-select: none;
        & > p {
          padding: 2px 22px;
          background-color: #ee9255;
          border-radius: 10px;
          cursor: pointer;
        }
      }
      .login-02 {
        font-size: 16px;
        user-select: none;
        & > p {
          position: relative;
          left: 120px;
          top: 23px;
        }
        span {
          font-weight: bolder;
          cursor: pointer;
        }
      }
    }

    // 当展示页面路径时
    .page-path {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000000;
      & > p {
        margin-bottom: 7px;
        font-weight: bolder;
        color: #2890db;
        span {
          color: #000000;
          // font-size:14px;
        }
      }
    }
  }
  // 输入区域
  .search {
    // width: 540px;
    width: 0;
    flex-grow: 1;
    height: 48px;
    border-radius: 20px;
    // padding: 0 24px;
    display: flex;
    align-items: center;
    position: relative;
    .input {
      height: 46px;
      width: 420px;
      box-sizing: border-box;
      padding-left: 31px;
      background-color: #fff;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      display: flex;
      align-items: center;
      input {
        width: 100%;
        height: 20px;
        border-width: 0;
        outline: none;
      }
    }
    .btn {
      width: 120px;
      height: 100%;
      padding: 15px 37px;
      box-sizing: border-box;
      color: #fff;
      background-color: #01449b;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }
    .search-items {
      width: 389px;
      max-height: 350px;
      overflow: auto;
      padding: 10px 20px 20px;
      box-sizing: border-box;
      // background-color: rgba(245, 245 ,245 , 0.6);
      background-color: #fff;
      position: absolute;
      top: 46px;
      left: 30px;
      border-radius: 10px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      // border: 1px solid #f5f5f5;
      border: 1px solid #f5f5f5;
      border-top-width: 0;
      .item {
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }
}
// el ui 样式重写
// icon定位
/deep/ .el-icon-s-home {
  color: #2890db;
  font-size: 18px;
  font-weight: bold;
  padding-right: 5px;
}
</style>
